<template>
    <div class="nav">
        <el-menu :unique-opened="true" :default-active="active" @select="goToPage">
            <el-submenu index="1">
                <template slot="title">
                    <span>租户管理</span>
                </template>
                <el-menu-item index="1-1">租户管理(企业)</el-menu-item>
                <el-menu-item index="1-2">租户管理（产品开发）</el-menu-item>
                <el-menu-item index="1-3">租户账号管理</el-menu-item>
            </el-submenu>
            <el-submenu index="2">
                <template slot="title">
                    <span>系统管理</span>
                </template>
                <el-menu-item index="2-1">开发人员管理</el-menu-item>
                <el-menu-item index="2-2">角色管理</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
                <template slot="title">
                    <span>资源管理</span>
                </template>
                <el-menu-item index="3-1">资源配置</el-menu-item>
                <el-menu-item index="3-2">套餐配置</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
                <template slot="title">
                    <span>版本管理</span>
                </template>
                <el-menu-item index="4-1">行业版本</el-menu-item>
                <el-menu-item index="4-2">租户版本</el-menu-item>
                <el-menu-item index="4-3">租户账号版本</el-menu-item>
            </el-submenu>
        </el-menu>
    </div>
</template>
<script>
    export default {
        props: ['active'],
        data: function(){
            return {}
        },
        created: function(){
        },
        methods: {
            goToPage(data) {
                localStorage.setItem("menuActive",data)
                switch(data) {
                    case '1-1':
                        this.$router.push('/management/enterprise')
                        break
                    case '1-2':
                        this.$router.push('/management/productdev')
                        break
                    case '2-1':
                        this.$router.push('/management/developermanagement')
                        break
                    case '2-2':
                        this.$router.push('/management/rolemanagement')
                        break
                    case '1-3':
                        this.$router.push('/management/account')
                        break
                    case '3-1':
                        this.$router.push('/management/resourceconfig')
                        break
                    case '3-2':
                        this.$router.push('/management/packageconfig')
                        break
                    case '4-1':
                        this.$router.push('/management/productversion')
                        break
                    case '4-2':
                        this.$router.push('/management/tenantversion')
                        break
                    case '4-3':
                        this.$router.push('/management/tenantaccountversion')
                        break
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Index.vue?553b5a1e